import React, { Component } from "react";
import MVPDs from "../data/mvpds.json";
import TableColumn from "./TableColumn.js";

class CableRow extends Component {
  render() {

    // let MVPD = MVPDs[this.props.name];
    let MVPD = MVPDs[this.props.operator];
    
    return (<div className={this.props.rowClass}>
        {MVPD ? (
            <div className="col-xs-3">
              <img className="provider-logo" src={MVPD} alt={this.props.operator} />
              {/* <img className="provider-logo" src={MVPD} alt={this.props.name}/> */}
            </div>
          
        ) : (
            <div className="col-xs-3">
              <div className="provider-name">{this.props.operator}</div>
              {/* <div className="provider-name">{this.props.name}</div> */}
            </div>
  
        )}              
        {this.props.mvpd.map((item,i) => <TableColumn key={i} HD={item.HD ? item.HD.channelNumber : "N/A"} SD={item.SD ? item.SD.channelNumber : "N/A"}/>
        )}                                                                                                                                                                                   
      </div>
    );
  }
}

export default CableRow;



// WEBPACK FOOTER //
// ./src/components/CableRow.js